import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgHelpCircle} from "~/assets/svg/help-circle.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmHelpCircleIcon: React.FC<IIconBase> = ({id, size = "xs", color = designColors.black, className}) => {
  return <SvgHelpCircle id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
